<app-popover>
  <div app-popover-content class="flex flex-col gap-4">
    <!-- <button
      app-outline-button
      type="button"
      class="flex border-theme-600 px-4 py-2 uppercase text-theme-600 hover:[&:not([disabled])]:bg-theme-600 hover:[&:not([disabled])]:text-theme-contrast"
    >
      <svg-icon
        class="w-6 text-theme-400 group-hover/dots:text-theme-500 md:w-8"
        src="assets/icons/icon-print.svg"
      ></svg-icon>
      <p class="px-2">Imprimir certificados</p>
    </button>
    <hr app-divider /> -->
    <button
      (click)="onOpenModal()"
      app-outline-button
      type="button"
      class="flex border-theme-600 px-4 py-2 uppercase text-theme-600 hover:[&:not([disabled])]:bg-theme-600 hover:[&:not([disabled])]:font-semibold hover:[&:not([disabled])]:text-theme-contrast"
    >
      <svg-icon
        class="w-6 text-theme-400 group-hover/dots:text-theme-500 md:w-8"
        src="assets/icons/icon-chart.svg"
      ></svg-icon>
      <p class="px-2">Visualizar Gráfico</p>
    </button>
    <button
      (click)="onExportExcel()"
      app-outline-button
      type="button"
      class="flex border-theme-600 px-4 py-2 uppercase text-theme-600 hover:[&:not([disabled])]:bg-theme-600 hover:[&:not([disabled])]:text-theme-contrast"
    >
      <svg-icon
        class="w-6 text-theme-400 group-hover/dots:text-theme-500 md:w-8"
        src="assets/icons/icon-doc-types.svg"
      ></svg-icon>
      <p class="px-2">Exportar Dados</p>
    </button>
  </div>
</app-popover>
<ng-container *ngIf="data.excelData.data$ | async as usersData">
  <table style="display: none" id="tableReport">
    <thead>
      <tr>
        <th colspan="3">{{ 'trilhas.relatorio.curso' | translate }}: {{ data.excelData.courseTitle }}</th>
      </tr>
      <tr>
        <th colspan="3">{{ 'trilhas.relatorio.evento' | translate }}: {{ data.excelData.eventTitle }}</th>
      </tr>
      <tr *ngIf="usersData.entidade.length === 1">
        <th colspan="3">{{ 'trilhas.relatorio.entidade' | translate }}: {{ usersData.entidade[0].nome }}</th>
      </tr>
      <tr *ngIf="!!data.excelData.eventTitle">
        <th colspan="3">
          {{ 'trilhas.relatorio.subdivisao-trilha' | translate }}:
          {{ data.excelData.eventTitle }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{{ 'trilhas.relatorio.nome' | translate }}</td>
        <td>{{ 'trilhas.relatorio.status' | translate }}</td>
        <td>{{ 'trilhas.relatorio.progresso' | translate }} (%)</td>
        <td>{{ 'geral.data-inicio' | translate }}</td>
        <td>{{ 'geral.data-fim' | translate }}</td>
        <td>{{ 'trilhas.estudio.curso.voucher' | translate }}</td>
      </tr>
      <tr *ngFor="let user of usersData.users">
        <td>{{ user.nome }}</td>
        <td>
          <ng-container [ngSwitch]="user.status">
            <ng-container *ngSwitchCase="FilterStatusEnum.NotEnrolled">
              {{ 'trilhas.relatorio.user-status-options.nao-matriculado' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="FilterStatusEnum.NotStarted">
              {{ 'trilhas.relatorio.user-status-options.nao-iniciado' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="FilterStatusEnum.Started">
              {{ 'trilhas.relatorio.user-status-options.andamento' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="FilterStatusEnum.Completed">
              {{ 'trilhas.relatorio.user-status-options.concluido' | translate }}
            </ng-container>
          </ng-container>
        </td>
        <td>{{ user.percent }}</td>
        <td>{{ user.data_inicio }}</td>
        <td>{{ user.data_conclusao }}</td>
        <td *ngIf="user.voucher">{{ 'geral.sim' | translate }}</td>
        <td *ngIf="!user.voucher">{{ 'geral.nao' | translate }}</td>
      </tr>
    </tbody>
  </table>
</ng-container>
